import Vue from 'vue'
import Vuex from 'vuex'

import { authentication } from './authentication.module'
import { toast } from './toast.module'
import rols from './modules/rols/index'
import users from './modules/users/index'
import jusers from './modules/json/users/index'
import languages from './modules/language/index'
import permissions from './modules/permissions/index'
import countries from './modules/countries/index'
import provinces from './modules/provinces/index'
import cities from './modules/cities/index'
import categories from './modules/categories/index'
import entities from './modules/entities/index'
import stadiums from './modules/stadiums/index'
import tournaments from './modules/tournaments/index'
import phases from './modules/phases/index'
import groups from './modules/groups/index'
import pitches from './modules/pitches/index'
import teams from './modules/teams/index'
import acts from './modules/acts'
import aspects from './modules/aspects'
import matches from './modules/matches'
import events from './modules/events'
import advertising from './modules/advertising'
import courses from './modules/courses'
import matchEvents from './modules/matchEvents'
import stats from './modules/stats'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    authentication,
    toast,
    rols,
    users,
    jusers,
    languages,
    permissions,
    cities,
    provinces,
    countries,
    categories,
    entities,
    stadiums,
    tournaments,
    phases,
    groups,
    pitches,
    teams,
    acts,
    aspects,
    matches,
    events,
    advertising,
    courses,
    matchEvents,
    stats
  }
})
